export const TalColumn = {
    domain: 'Domain',
    accountCategory: 'Account Category',
    accountCategory2: 'Account Category 2',
    accountCategory3: 'Account Category 3',
    companyName: 'Company Name',
    industry: 'Industry',
    region: 'Region',
    revenueSize: 'Revenue Size',
    employeeSize: 'Employee Size',
    clientProvidedAccount: 'Client Provided Account',
    lookalikeAccount: 'Lookalike Account',
};
export const TalColumnValidation = {
    [TalColumn.domain]: { required: true },
    [TalColumn.companyName]: { required: false },
    [TalColumn.accountCategory]: { required: false },
    [TalColumn.accountCategory2]: { required: false },
    [TalColumn.accountCategory3]: { required: false },
    [TalColumn.industry]: { required: false },
    [TalColumn.region]: { required: false },
    [TalColumn.revenueSize]: { required: false },
    [TalColumn.employeeSize]: { required: false },
    [TalColumn.clientProvidedAccount]: { required: false, boolean: true },
    [TalColumn.lookalikeAccount]: { required: false, boolean: true },
};
export const TalColumnValidationEntries = Object.entries(TalColumnValidation);
export const TalColumnCount = TalColumnValidationEntries.length;
export const TalColumns = TalColumnValidationEntries.map(([columnName]) => columnName);
export const TalColumnsString = TalColumns.join(',');
export const TalColumnTemplate = Object.fromEntries(TalColumnValidationEntries.map(([columnName, columnConfig]) => {
    const values = [];
    if (columnConfig.required) {
        values.push('required');
    }
    if ('boolean' in columnConfig && columnConfig.boolean) {
        values.push('yes or no');
    }
    return [columnName, values.length > 0 ? `(${values.join(', ')})` : ''];
}));
//# sourceMappingURL=talColumns.js.map